import { LoadingButton } from '@mui/lab';
import {
  Box,
  FormControl,
  InputAdornment,
  SvgIcon,
  TextField,
} from '@mui/material';
import { ChangeEvent, FunctionComponent, useCallback } from 'react';
import { MdSearch as SearchIcon } from 'react-icons/md';
import { makeStyles } from 'tss-react/mui';
import CustomTooltip from '../../common/components/CustomTooltip';

const ConnectorsListToolbar: FunctionComponent<
  React.PropsWithChildren<ConnectorsListToolbarProps>
> = ({
  isScanAllDisabled,
  handleSearch,
  credentialsValidationInProgress,
  validateAllCredentials,
  searchValue,
}) => {
  const { classes } = useStyles();

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      handleSearch(value);
    },
    [handleSearch],
  );

  return (
    <Box
      display='flex'
      justifyContent='space-between'
      width='100%'
      alignItems='center'>
      <Box maxWidth={500}>
        <FormControl className={classes.fullWidth}>
          <TextField
            fullWidth
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <SvgIcon component={SearchIcon} />
                </InputAdornment>
              ),
            }}
            placeholder='Search connector'
            variant='outlined'
            value={searchValue}
            onChange={onChange}
          />
        </FormControl>
      </Box>
      <Box display='flex'>
        <CustomTooltip title='Validate all connectors credentials.'>
          <Box display='flex' alignItems='center' mr={1.5}>
            <LoadingButton
              variant='contained'
              onClick={validateAllCredentials}
              loading={credentialsValidationInProgress}
              color='primary'
              disabled={isScanAllDisabled}>
              Verify Connectivity
            </LoadingButton>
          </Box>
        </CustomTooltip>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()({
  fullWidth: {
    width: '100%',
  },
});

export interface ConnectorsListToolbarProps {
  isScanAllDisabled: boolean;
  isScanning: boolean;
  credentialsValidationInProgress: boolean;
  searchValue: string;
  handleSearch: (searchInput: string) => void;
  validateAllCredentials: () => void;
}

export default ConnectorsListToolbar;
